import { render, staticRenderFns } from "./channelFlow.vue?vue&type=template&id=04c22d80&scoped=true"
import script from "./channelFlow.vue?vue&type=script&lang=js"
export * from "./channelFlow.vue?vue&type=script&lang=js"
import style0 from "./channelFlow.vue?vue&type=style&index=0&id=04c22d80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c22d80",
  null
  
)

export default component.exports